goog.provide('el8.data.letterRoutes');

goog.require('el8.service.urls');
goog.require('el8.model.base');

// Provides the denormalized list of letter routing rules keyed by physician (including any
// fallback routes).

el8.data.letterRoutes = (function() {
    var _rule = function(spec) { this.populate(spec); };
    _rule.inheritsFrom(el8_Entity);
    _rule.addIntProperty('physicianUserId', true);
    _rule.addStringProperty('category', true);
    _rule.addProperty('userIds', true, []);
    _rule.addProperty('staffgroupIds', true, []);
    _rule.addBoolean('forBulkUpdate', true, false);

    // routes object by provider
    var _routes = function(spec) { this.populate(spec); };
    _routes.inheritsFrom(el8_Entity);
    _routes.addIntProperty('physicianUserId', true);
    _routes.addModelSetProperty('rules', function(spec) { return new _rule(spec); }, true, []);

    var that =  new el8_EntitySet({
        model: function(spec) { return new _routes(spec); },
        key: 'physicianUserId',     // will create _getter as getPhysicanUserId()
        items: [],
        urlLoad: function () { return el8.service.urls.get('letterRoutes',
                                                           [el8.data.currPractice.getId()]); }
    });

    // We only need to post one set of routes both for bulk update or a single provider
    // physician_user_id is null for bulk update, and the routes to update are forBulkUpdate == true
    that.saveAll = function (physician_user_id, successCb) {
        var routes = [];
        if (!physician_user_id) { routes = this.all()[0].getRules(); }
        else { routes = this.getByKey(physician_user_id).getRules(); }

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('letterRoutes', [el8.data.currPractice.getId()]),
            data: {
                'data': JSON.stringify({
                    for_physician_user_id: physician_user_id,
                    routes: _(routes).map(function(r) { return r.asMap(true); }) // true for _'s
                 })
            },
            success: function() {
                // clear setForBulkUpdate's
                _(el8.data.letterRoutes.all()).each(function (physRouteObj) {
                    _(physRouteObj.getRules()).each(function (rule) {
                            rule.setForBulkUpdate(false);
                        }
                    );
                });

                successCb();
            }
        });
    };

    return that;
})();
